var exports = {
  "kL": "x112a1f60--6df925--container",
  "Sl": "x112a1f60--6df925--image",
  "wm": "x112a1f60--6df925--logo",
  "h_": "x112a1f60--6df925--description",
};

module.exports = exports;
